import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";
import SectionHeader from "./SectionHeader";

const ScoreSection: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
}) => {
  const { t } = useTranslation("wizard-activity");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SectionHeader
        title={t("sections.score.title")}
        description={t("sections.score.description") || undefined}
      />
      <InputCst
        id="activity-score"
        label={t("fields.score") || ""}
        value={data.score}
        onChange={(e: any) => setData({ score: e.target.value })}
        type="number"
        min={0}
      />
    </Box>
  );
};

export default ScoreSection;
